import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { IconButton } from '@ff-os/shared-react/components/buttons/icon-button/IconButton';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectCanUpdateFontWeightById, selectFontWeightById, updateFontWeightByIds } from '../../_redux';

const _Bold = ({ active, update, enabled }: Props) => {

    const { t } = useTranslation();

    const onClick = () => {
        if (enabled) {
            update(!active);
        }
    };

    return (
        <IconButton
            active={active} onClick={onClick} disabled={!enabled}
            title={t('styling_options.bold')}>
            <Icon type='bold' strokeWidth={3} />
        </IconButton>
    );
};

type Props = {
    active: boolean;
    enabled: boolean;
    update: (bold: boolean) => void;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    active: selectFontWeightById(state, ownProps.variableIds[0]!) === 'bold',
    enabled: selectCanUpdateFontWeightById(state, ownProps.variableIds[0]!)
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { variableIds: string[] }) => ({
    update: (bold: boolean) => {
        dispatch(updateFontWeightByIds(ownProps.variableIds, bold ? 'bold' : 'normal'));
    }
});

export const Bold = connect(
    mapStateToProps,
    mapDispatchToProps
)(_Bold);